import { Component } from '@angular/core';

@Component({
  selector: 'app-header-nav',
  imports: [],
  templateUrl: './header-nav.html',
  styleUrl: './header-nav.scss'
})
export class HeaderNav {
  readonly domain = window.location.hostname;
}
